<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Formas de Pagamento</h1>
        <paragrafo
          >Aqui estão todas as formas de pagamento aceitas. As que estiverem
          ativas aparecerão na aba Loja/Gerenciar/Editar/Dados
          Financeiros.</paragrafo
        >
        <imagem :src="image_1" />
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "FormasPagamento",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Financeiro/financeiro2.png",
    };
  },
};
</script>
